import Page from '../../common/page'

const state = Object.assign({}, Page.state)
state.endpoint = 'files/deleted'
state.sortOptions = {
  'Date': ['-created_datetime'],
  'Name': ['name']
}

export default {
  namespaced: true,
  state,
  getters: Page.getters,
  mutations: Page.mutations,
  actions: Page.actions
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/files/trash/trash.js